import { AxiosError } from 'axios';

export interface IdResponse {
  id: string;
}
export interface SuccessResponse {
  success: boolean;
}

export type ApiErrorResponse = {
  error: {
    code: string;
    description: string;
    additionalInfo: object;
  };
  request: {
    uri: string;
    method: string;
    queryString: string;
    body: object;
  };
};

export type ApiResponse<T> = {
  request: {
    uri: string;
    method: string;
    queryString: string;
    body: object;
  };
  data: T;
};

export type Invitation = {
  emailId: string;
  requestType: TeamJoinType;
  id: string;
  role: TeamRole;
  status: TeamMemberPendingRequestStatus;
  userFullName: string;
};

export class ApiError extends Error {
  response: ApiErrorResponse;
  httpCode: number;

  constructor(axiosError: any) {
    super(axiosError?.response?.data.error.description);
    this.httpCode = axiosError.status;
    this.response = axiosError?.response?.data;
  }

  static isApiError(error: any) {
    if (error instanceof AxiosError === false) {
      return false;
    }

    const response = error.response?.data as ApiErrorResponse;

    return response.error && response.request;
  }
}
